/**
 * Bag of the product cards with one option to pick (snippets/card-quick-add.liquid), like Bershka's:
 * - desktop (990px and up): the sizes show over the bottom of the photo (the <dialog> opened in place,
 *   not modal); a click elsewhere, Escape, the keyboard focus leaving them or the pointer leaving the card
 *   closes them;
 * - smaller screens: the same <dialog class="size-sheet"> opens as the product page's size sheet
 *   (bottom sheet on phones, modal), with the model's height under the sizes; Tab stays in it.
 * Picking a size puts its variant in the card's product form and submits it with the bag as submitter,
 * so the theme's add to cart runs as for any product form (fly-to-cart, drawer, gifts). Sold-out sizes
 * are disabled buttons, as is a size the store refuses (sold out since the page was loaded).
 */
(function () {
  if (window.customElements.get('rd-quick-sizes')) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var current = null;

  class QuickSizes extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.toggle = this.querySelector('[data-rd-quick-sizes-toggle]');
      this.panel = this.querySelector('dialog.rd-quick-sizes__panel');
      this.form = this.querySelector('form');
      if (!this.toggle || !this.panel || !this.form || typeof this.panel.show !== 'function') return;
      this.ready = true;
      this.onOutside = this.onOutside.bind(this);
      this.onKey = this.onKey.bind(this);

      this.toggle.addEventListener('click', (event) => {
        if (this.submitting) return; // the size picked submits the form through the bag
        event.preventDefault();
        if (this.panel.open) this.close(true);
        else this.open(event.detail === 0);
      });

      this.panel.addEventListener('click', (event) => {
        var size = event.target.closest('.size-sheet__size');
        if (size) {
          this.pick(size);
          return;
        }
        if (event.target.closest('.size-sheet__close')) {
          this.close(true);
          return;
        }
        // a click on the sheet's backdrop (modal): outside the dialog box
        if (event.target === this.panel && this.panel.matches(':modal')) {
          var box = this.panel.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
            this.close(true);
          }
        }
      });

      // Escape (also the modal sheet's own cancel) closes the sizes only: the layer or drawer around the card stays
      this.panel.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close(true);
      });

      // the keyboard focus leaving the in-place list closes it
      this.addEventListener('focusout', (event) => {
        if (!this.panel.open || this.panel.matches(':modal')) return;
        var next = event.relatedTarget;
        if (next && !this.contains(next)) this.close(false);
      });

      var card = this.closest('.card-wrapper') || this.parentElement;
      card.addEventListener('mouseleave', () => {
        if (this.panel.open && !this.panel.matches(':modal') && !this.panel.contains(document.activeElement)) this.close(false);
      });

      // an add refused by the store (a size sold out since the page was loaded): the theme's product form marks the
      // whole bag sold out and would refuse every other size; only that size is, so its row is disabled and the bag
      // works again
      var message = this.toggle.querySelector('.sold-out-message');
      if (message) {
        new MutationObserver(() => {
          if (message.classList.contains('hidden')) return;
          var productForm = this.form.closest('product-form');
          if (productForm) productForm.error = false;
          if (this.picked) this.picked.disabled = true;
          message.classList.add('hidden');
          var label = this.toggle.querySelector('span');
          if (label) label.classList.remove('hidden');
          this.toggle.removeAttribute('aria-disabled');
        }).observe(message, { attributes: true, attributeFilter: ['class'] });
      }
    }

    open(fromKeyboard) {
      if (current && current !== this) current.close(false);
      current = this;
      this.panel.classList.remove('is-closing');
      if (desktop.matches) this.panel.show();
      else this.panel.showModal();
      this.toggle.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      if (this.panel.matches(':modal') || fromKeyboard) {
        var first = this.panel.querySelector('.size-sheet__size:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }
      document.addEventListener('pointerdown', this.onOutside, true);
      document.addEventListener('keydown', this.onKey, true);
    }

    onKey(event) {
      // the modal sheet keeps Tab: from its last button back to its first, and the other way round
      if (event.key === 'Tab' && this.panel.open && this.panel.matches(':modal')) {
        var items = Array.prototype.filter.call(this.panel.querySelectorAll('button:not(:disabled)'), function (item) {
          return item.getClientRects().length > 0;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;
        var to = null;
        if (!this.panel.contains(active)) to = event.shiftKey ? last : first;
        else if (event.shiftKey && active === first) to = last;
        else if (!event.shiftKey && active === last) to = first;
        if (to) {
          event.preventDefault();
          to.focus();
        }
        return;
      }
      if (event.key !== 'Escape' || !this.panel.open || this.closing) return;
      event.preventDefault();
      event.stopPropagation();
      // the matching keyup must not reach the layer or drawer around the card either
      var up = function (e) {
        if (e.key !== 'Escape') return;
        e.preventDefault();
        e.stopPropagation();
        document.removeEventListener('keyup', up, true);
      };
      document.addEventListener('keyup', up, true);
      this.close(true);
    }

    onOutside(event) {
      if (!this.panel.open || this.panel.matches(':modal')) return;
      if (!this.contains(event.target)) this.close(false);
    }

    close(returnFocus, then) {
      document.removeEventListener('pointerdown', this.onOutside, true);
      document.removeEventListener('keydown', this.onKey, true);
      if (this.closing) return;
      if (current === this) current = null;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      if (!this.panel.open) {
        if (then) then();
        return;
      }
      this.closing = true;
      var finish = () => {
        this.closing = false;
        this.panel.classList.remove('is-closing');
        if (this.panel.open) this.panel.close();
        if (returnFocus) this.toggle.focus({ preventScroll: true });
        if (then) then();
      };
      // the modal sheet slides out first (0.2s on phones, 0.4s as a side panel)
      if (this.panel.matches(':modal') && !reducedMotion.matches) {
        var done = false;
        var end = () => {
          if (done) return;
          done = true;
          finish();
        };
        this.panel.classList.add('is-closing');
        this.panel.addEventListener('animationend', end, { once: true });
        setTimeout(end, 450);
      } else {
        finish();
      }
    }

    pick(size) {
      if (size.disabled || this.submitting) return;
      var input = this.form.querySelector('[name="id"]');
      if (!input) return;
      input.disabled = false;
      input.value = size.dataset.variantId;
      this.picked = size;
      this.close(false, () => {
        // the bag is the form's submit button: the theme's product form adds the variant and, from the
        // bag, plays its fly-to-cart animation; focus waits on the bag (the drawer returns it there)
        this.toggle.focus({ preventScroll: true });
        this.submitting = true;
        try {
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.toggle);
          else this.toggle.click();
        } finally {
          this.submitting = false;
        }
      });
    }
  }

  window.customElements.define('rd-quick-sizes', QuickSizes);
})();
